import { IDeviceTruckImplement } from 'app/shared/model/device-truck-implement.model';

export interface ISensorHardwareDevice {
    id?: number;
    manufacturer?: string | null;
    model?: string | null;
    description?: string | null;
    equation?: string | null;
    deviceTruckImplement?: IDeviceTruckImplement | null;
  }
  
  export const defaultValue: Readonly<ISensorHardwareDevice> = {};
  